import Controller from '@ember/controller';
import { get } from '@ember/object';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';

export default Controller.extend({
  fundsService: service(),
  router: service(),
  storeCache: service(),
  flashMessages: service(),
  cachedDataset: service(),

  delete: task(function* () {
    let record = get(this, 'model.record');
    let displayName = get(record, 'displayName');
    yield this.fundsService.confirmValidFundToken();
    yield record.destroyRecord();
    this.flashMessages.success(`${displayName} has been deleted`);
    this.storeCache.breakFindAllCache('admin/user');
    this.storeCache.breakFindAllCache('admin/user-fund');

    this.cachedDataset.forModel('admin/user').remove(record);
    this.router.transitionTo('admin.users');
  }).drop(),
});
